<dx-scroll-view height="100%" width="100%" class="with-footer single-card">
  <div class="dx-card content">
    <ng-content></ng-content>
  </div>
</dx-scroll-view>
